import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-white py-8 md:py-16" data-id="element-94">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-orange-50 border border-orange-200 rounded-lg p-6 md:p-12 text-center" data-id="element-96">
          <div className="flex justify-center mb-4 md:mb-6" data-id="element-97">
            <div className="bg-orange-500/10 p-4 rounded-full" data-id="element-98">
              <ShieldIcon className="w-12 h-12 text-orange-500" data-id="element-99" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6" data-id="element-100">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-gray-600 mb-4 md:mb-6 leading-relaxed" data-id="element-101">
            Abrís los tomos. Probás las recetas. Aplicás las técnicas. Si en 7
            días no es lo que esperabas: devolución del 100% — sin formularios,
            sin drama, sin explicaciones.
            <br data-id="element-102" />
            <br data-id="element-103" />
            Confiamos en el producto. Por eso damos la garantía sin dudar.
          </p>

          <p className="text-xl font-bold text-orange-500" data-id="element-104">
            Tasa de devoluciones: menos del 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}